/**
 * Entry point.
 *
 * NFR-3: no unhandled exception may kill the process during a draft. The two
 * global handlers below are the last line of that defence — the UI degrades to
 * its last-known-good state with a visible warning rather than going blank,
 * because draft night is exactly when you cannot ship a fix.
 */

import './ui/styles.css';
import { mount } from './ui/app.ts';

const root = document.getElementById('app');

if (!root) {
  document.body.textContent = 'Draft Puppy could not start: #app is missing.';
} else {
  const store = mount(root);

  const warn = (message: string) => {
    const existing = document.querySelector('.global-warning');
    if (existing) existing.remove();
    const banner = document.createElement('div');
    banner.className = 'global-warning';
    banner.setAttribute('role', 'alert');
    banner.textContent = `${message} The board is still showing your last good state.`;
    document.body.appendChild(banner);
    setTimeout(() => banner.remove(), 12_000);
  };

  window.addEventListener('error', (event) => {
    console.error('[draftpuppy]', event.error ?? event.message);
    warn('Something went wrong.');
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[draftpuppy]', event.reason);
    warn('A background request failed.');
  });

  // NFR-4: draft-day wifi is a real risk, so react to it explicitly rather than
  // letting polls fail silently in the background.
  window.addEventListener('offline', () => {
    store.update({ connection: 'offline' });
  });
  window.addEventListener('online', () => {
    void store.pollOnce();
  });

  // Stop polling while the tab is hidden — a phone in a pocket does not need to
  // keep hitting Sleeper, and NFR-5 is a shared budget across all users.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) store.stopPolling();
    else if (store.get().phase === 'board') {
      store.startPolling({ immediate: true });
    }
  });
}
